import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { START_ICON } from '@src/slide/domain/ui-model/element-modeles/property/animation/anim-icon';

export const config = {
    id: ActionType.ANIM_START,
    icon: START_ICON,
    content: i18n.t('开始方式'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        tooltip: config.content,
    },
];

const menuStyle = {
    minWidth: 68,
};

export const ANIM_START_CONFIG: MenuConfig[] = [
    { name: ActionType.CLICK_EFFECT, content: i18n.t<string>('单击时'), style: menuStyle },
    { name: ActionType.WITH_EFFECT, content: i18n.t<string>('与上一个同时'), style: menuStyle  },
    { name: ActionType.AFTER_EFFECT, content: i18n.t<string>('在上一个之后'), style: menuStyle  },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
    ...ANIM_START_CONFIG,
];
